import LoginImage from './assets/APA_Logo_Stacked_1cRev_lr.png';
import dummyVideos from './data/dummyVideos';
import MatchboxIcon from './assets/favicon.ico';
import MatchboxLogo from './assets/matchbox-logo-white-small.png';

const SiteData = {
  loginTitle:
    "APA Addresses Structural Racism Town Hall Part IV",
  loginImagesrc: LoginImage,
  loginImagealt: 'APA Logo',
  attendeeTitle:
    'APA Addresses Structural Racism Town Hall Part IV',
  matchboxLogo: MatchboxIcon,
  matchboxIcon: MatchboxLogo,
  endOfEventPageTitle:
    'APA Addresses Structural Racism Town Hall Part IV',
  matchboxLogoAlt: 'matchbox logo',
  matchboxLogoTitle: 'hello',
  attendantTitle: 'Event Console',
  titleIndex: 'APA Town Hall IV',
  auditorium: true,
  checkRegisterList: false,
  primary_color: "#1A355E",
	secondary_color: "darkblue",
  generalChatId: 1,
  auditoriumChatIds: [2],
  schemaName: 'apatownhall',
  Isbanner: false,
  isMultipleAuditorium: false,
  // bannerData: {
  //   backgroundURL: bannerImage,
  //   videoURL:
  //     'https://expohallimages.s3-us-west-2.amazonaws.com/STE+Pre-Show.mp4',
  // },
};
export default SiteData;
